import * as styles from "./ArticleMeta.module.scss";

import TaggedTopics, { type TopicTag } from "../TaggedTopics/TaggedTopics";

import React from "react";
import AuthorAttribution from "../AuthorAttribution";

export interface ArticleMetaProps {
	author?: string;
	tags?: TopicTag[];
}
export const ArticleMeta: React.FC<ArticleMetaProps> = ({
	author = "",
	tags = [],
}) => {
	if (author?.length > 0 && tags.length === 0) return null;
	return (
		<div className={styles.wrapper}>
			{tags.length ? <TaggedTopics tags={tags} /> : null}
			{author?.length ? <AuthorAttribution author={author} /> : null}
		</div>
	);
};

export default ArticleMeta;
